import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { GET_DASHBOARD_V2_STATIONS } from 'actions/dashboardV2';
import Card from 'components/inputs/Card';
import Loader from 'components/general/Loader';

const COMBOS = [
  { type: 'top', category: 'revenue', title: 'Top 10 — Highest Revenue' },
  { type: 'top', category: 'utilization', title: 'Top 10 — Highest Utilization' },
  { type: 'worst', category: 'revenue', title: 'Worst 10 — Lowest Revenue' },
  { type: 'worst', category: 'utilization', title: 'Worst 10 — Lowest Utilization' },
];

const StationTable = ({ title, rows = [], isLoading }) => (
  <Card>
    <h6 style={{ fontWeight: 600, marginBottom: 12 }}>{title}</h6>
    {isLoading ? (
      <div style={{ minHeight: 200, position: 'relative' }}>
        <Loader />
      </div>
    ) : (
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#be210b' }}>
              {['Station', 'Revenue (₹)', 'Sessions', 'Utilization %', 'Downtime %'].map((h) => (
                <th key={h} style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#fff' }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ padding: 16, textAlign: 'center', color: '#888' }}>
                  No data
                </td>
              </tr>
            ) : (
              rows.map((row, idx) => (
                <tr
                  key={idx}
                  style={{ borderBottom: '1px solid #2a3a47' }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(190,33,11,0.1)')}
                  onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                >
                  <td style={{ padding: '9px 12px' }}>{row.station}</td>
                  <td style={{ padding: '9px 12px' }}>{row.revenue}</td>
                  <td style={{ padding: '9px 12px' }}>{row.sessions}</td>
                  <td style={{ padding: '9px 12px' }}>{row.utilizationPct}%</td>
                  <td style={{ padding: '9px 12px' }}>{row.downtimePct}%</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )}
  </Card>
);

const StationTables = () => {
  const dispatch = useDispatch();
  const { stations, isStationsLoading } = useSelector((state) => state.dashboardV2);
  const [period, setPeriod] = useState('daily');

  const fetchAll = (p) => {
    COMBOS.forEach(({ type, category }) => {
      dispatch({ type: GET_DASHBOARD_V2_STATIONS.REQUEST, payload: { period: p, type, category } });
    });
  };

  useEffect(() => {
    fetchAll(period);
  }, [period]);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
        <span style={{ fontWeight: 600 }}>Station Performance</span>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 4 }}>
          {['daily', 'weekly'].map((p) => (
            <button
              key={p}
              onClick={() => setPeriod(p)}
              style={{
                padding: '4px 14px',
                borderRadius: 4,
                border: `1px solid ${period === p ? '#be210b' : '#3b4a56'}`,
                background: period === p ? '#be210b' : 'transparent',
                color: '#fff',
                cursor: 'pointer',
                fontWeight: period === p ? 600 : 400,
                textTransform: 'capitalize',
              }}
            >
              {p === 'daily' ? 'Yesterday' : 'Last 7 Days'}
            </button>
          ))}
        </div>
      </div>
      <Row>
        {COMBOS.map(({ type, category, title }) => (
          <Col key={`${type}_${category}`} md={6} style={{ marginBottom: 16 }}>
            <StationTable
              title={title}
              rows={stations[`${type}_${category}`]}
              isLoading={isStationsLoading}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

StationTable.propTypes = {
  title: PropTypes.string,
  rows: PropTypes.array,
  isLoading: PropTypes.bool,
};

export default StationTables;
